// extracted by mini-css-extract-plugin
export default {"head":"PageHead_head__5kOJh","crumb":"PageHead_crumb__A-WxC","title":"PageHead_title__2jMNN","actions":"PageHead_actions__mcheJ"};